import React, { useState } from "react";
import { motion } from "framer-motion";

const AmsaKattam = ({ setAmsaValues, amsaValues, readOnly = false, injectClass, kattamOuterInjectClass=undefined, kattamInnerInjectclass=undefined }) => {

    const [rasiPlanets, setRasiPlanets] = useState(amsaValues || [
        [], [], [], [],
        [], null, null, [],
        [], null, null, [],
        [], [], [], []
    ]);
    const planets = ['சூ', 'சந்', 'செவ்', 'பு', 'குரு', 'சுக்', 'சனி', 'ரா', 'கே', 'ல', 'மா'];

    const handlePlanetChange = (index, planet) => {
        if (rasiPlanets[index] === null) {
            return; // Don't allow changes in null cells
        }

        const newRasiPlanets = [...rasiPlanets];
        const planetIndex = newRasiPlanets[index].indexOf(planet);

        if (planetIndex === -1) {
            newRasiPlanets[index] = [...newRasiPlanets[index], planet];
        } else {
            newRasiPlanets[index].splice(planetIndex, 1);
        }

        const updatedRasi = newRasiPlanets.map((boxPlanets, boxIndex) => {
            if (boxIndex !== index && newRasiPlanets[boxIndex] !== null) {
                return boxPlanets.filter((p) => p !== planet);
            }
            return boxPlanets;
        });

        setRasiPlanets(updatedRasi);
        setAmsaValues(updatedRasi)
    };

    return (
        <motion.div className={`w-full h-full relative flex flex-col justify-center rasi-print-scale  items-center ${injectClass}`}>
            <motion.div className={`border border-black relativ ${kattamOuterInjectClass ? kattamOuterInjectClass : 'h-[800px] w-[800px]'}`}>
                <motion.div className="grid grid-cols-4 grid-rows-4 gap-0">
                    {rasiPlanets.map((box, i) => {
                        return (
                            <motion.div
                                key={i}
                                className={`border border-black ${box === null ? "border-none" : "flex flex-col justify-center items-center"} ${kattamInnerInjectclass ? kattamInnerInjectclass : 'h-[200px] w-[200px]'}`}
                            >
                                {box !== null && (
                                    <>
                                        {!readOnly && <div className="flex flex-wrap justify-center">
                                            {planets.map((p) => (
                                                <button
                                                    key={p}
                                                    onClick={() => handlePlanetChange(i, p)}
                                                    className={`m-1 p-1 border cursor-pointer rounded ${box.includes(p) ? "bg-primeColor text-white" : "bg-grey-200 text-black"}`}
                                                    style={{ pointerEvents: 'auto' }} // Explicitly set pointer-events to auto
                                                >
                                                    {p}
                                                </button>
                                            ))}
                                        </div>}
                                        {readOnly && <div className="mt-2 flex flex-wrap gap-1 px-2 text-center">
                                            {box.map((p) => (
                                                <div key={p} className="mr-1 text-primeColor font-bold text-sm">
                                                    {p}
                                                </div>
                                            ))}
                                        </div>}
                                    </>
                                )}

                            </motion.div>
                        );
                    })}
                </motion.div>
                <motion.div className="absolute inset-0 flex justify-center items-center pointer-events-none">
                    <motion.div className="text-3xl font-bold text-primeColor">
                    அம்சம்
                    </motion.div>
                </motion.div>
            </motion.div>
        </motion.div>
    );
};

export default AmsaKattam;